const modalManageMemberPresetId = (licensePresetId) => {
    return 'msync-org-edit-group-preset-' + licensePresetId
}

const modalCreateMemberPresetId = 'msync-org-create-group-preset'

export{
    modalManageMemberPresetId,
    modalCreateMemberPresetId
  }
